import { BsFolder } from "react-icons/bs";
import { Link } from "react-router-dom";
function Action(props) {
  return (
    <div className="flex">
      <Link to={"/services/beneficiaries/profile/"}>
        <button
          className="flex p-1 rounded  border border-gray-100 bg-gray-100 hover:border-indigo-300  text-indigo-500 hover:text-indigo-500 title-tip title-tip-left"
          message="Profile"
        >
          <BsFolder />
        </button>
      </Link>
    </div>
  );
}
export default Action;
